import { put } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import { saveRoundBetAction, saveRoundBetSuccessAction } from '../actions';
import { sumBets } from 'widgets/Roulette/helpers';
import { IClientBet } from 'widgets/Roulette/types';

export function* saveRoundBetSaga({
  payload: confirmedBets,
}: ActionType<typeof saveRoundBetAction>) {
  const bets = confirmedBets;

  const betSum = confirmedBets.length ? sumBets(bets) : 0;
  const roundBet: IClientBet[] | null = betSum > 0 ? bets : null;

  yield put(saveRoundBetSuccessAction(roundBet));
}
